const marginTopCalc = () => {
  const navBarElement = document.getElementById("main-nav-bar");
  const announcentBar = document.getElementById("announcement-bar");
  const mainContent = document.getElementById("MainContent");

  const navBarElementHeight = navBarElement.offsetHeight;
  const space = 10;
  const setPaddingValueWithoutBar = (navBarElementHeight + space).toString().concat('px');

  if (announcentBar !== null) {
    const announcentBarHeight = announcentBar.offsetHeight;
    const setPaddingValueWithBar = (navBarElementHeight + announcentBarHeight + space).toString().concat('px');

    return mainContent.style.marginTop = setPaddingValueWithBar;
  }

  return mainContent.style.marginTop = setPaddingValueWithoutBar;
};

window.addEventListener("load", marginTopCalc);